import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// vehicle_colors — สีรถ
// ============================================================================
export const vehicleColors = sqliteTable("fleet_vehicle_colors", {
  id: text("id").primaryKey(), // ULID
  name: text("name").notNull(),
  nameTh: text("name_th"),
  hexCode: text("hex_code"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleColor = typeof vehicleColors.$inferSelect;
export type NewVehicleColor = typeof vehicleColors.$inferInsert;
